import { Button } from '@mui/material';

import { ReferralProgramsProvider } from 'modules/strapi/components/ReferralProgramsProvider';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import {
  IReferralCodeDialogProps,
  ReferralCodeDialog,
} from '../ReferralCodeDialog';
import { ISuccessDialogProps, SuccessDialog } from '../SuccessDialog';
import { referralCodeButtonTranslation } from './translation';
import { useReferralCodeButtonStyles } from './useReferralCodeButtonStyles';

export interface IReferralCodeButtonProps {
  className?: string;
  handleReferralCodeDialogOpen: () => void;
  isVisible?: boolean;
  referralCodeDialogProps: IReferralCodeDialogProps;
  successDialogProps: ISuccessDialogProps;
}

export const ReferralCodeButton = ({
  className,
  handleReferralCodeDialogOpen,
  isVisible,
  referralCodeDialogProps,
  successDialogProps,
}: IReferralCodeButtonProps) => {
  const { classes, cx } = useReferralCodeButtonStyles();
  const { keys, t } = useTranslation(referralCodeButtonTranslation);

  return (
    <ReferralProgramsProvider>
      {isVisible && (
        <Button
          className={cx(classes.root, className)}
          onClick={handleReferralCodeDialogOpen}
          size="small"
          variant="text"
        >
          {t(keys.label)}
        </Button>
      )}
      <ReferralCodeDialog {...referralCodeDialogProps} />
      <SuccessDialog {...successDialogProps} />
    </ReferralProgramsProvider>
  );
};
